import React from 'react';
import PropTypes from 'prop-types';

const IconButton = ({ onClick, label, title, className = '', children }) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2';
  
  // Default size and style, can be overridden by className
  const styles = 'w-10 h-10 bg-gray-100 text-gray-600 hover:bg-gray-200 hover:scale-105';

  return (
    <button
      onClick={onClick}
      aria-label={label}
      title={title || label}
      className={`${baseClasses} ${styles} ${className}`}
    >
      {children}
    </button>
  );
};

IconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default IconButton;
